import moment from 'moment';

export const getTimeStamp = (unix: number, feed = false, mobile = false) => {
  const momentInstance = moment.unix(unix).local(true);

  if (momentInstance.isSame(moment(), 'day')) {
    return momentInstance.format('h:mm A');
  } else if (momentInstance.isSame(moment(), 'year')) {
    return momentInstance.format(feed || mobile ? 'MMM DD' : 'h:mm A MMM DD');
  }

  return momentInstance.format(
    feed || mobile ? 'MMM DD, YYYY' : 'h:mm A MMM DD, YYYY'
  );
};

export const isADayAgo = function (input: moment.Moment) {
  const yesterday = moment().subtract(1, 'd').startOf('day');
  return moment(input).isSame(yesterday, 'd');
};

export const getFormattedTime = (unix: number) => {
  moment.updateLocale('en', {
    relativeTime: {
      future: 'in %s',
      past: '%s ago',
      s: 'seconds',
      m: '1 minute',
      mm: '%d minutes',
      h: '1 hour',
      hh: '%d hours',
      d: '1 day',
      dd: '%d days',
      M: '1 month',
      MM: '%d months',
      y: '1 year',
      yy: '%d years',
    },
  });
  const momentInstance = moment.unix(unix).local(true);
  if (isADayAgo(momentInstance)) {
    return momentInstance.from(moment());
  }
  if (momentInstance.isSame(moment(), 'day')) {
    return momentInstance.fromNow();
  } else if (momentInstance.isSame(moment(), 'year')) {
    return momentInstance.format('MMM DD');
  }
  return momentInstance.format('MMM DD, YYYY');
};
